import React, { FunctionComponent, SyntheticEvent } from 'react';
import { Box, Typography } from '@material-ui/core';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import variantCategoryTabsStyles from './VariantCategoryTabsStyles';
import stringUtilities from '../../../../../../common/utilities/stringUtilities';

export interface IVariantCategoryTabs {
  marketingCategories: string[];
  selectedMarketingCategory: string;
  setMarketingCategory: (_e: SyntheticEvent, category: string) => void;
}

const VariantCategoryTabs: FunctionComponent<IVariantCategoryTabs> = ({
  marketingCategories,
  selectedMarketingCategory,
  setMarketingCategory,
}) => {
  const styles = variantCategoryTabsStyles();

  if (!selectedMarketingCategory || !marketingCategories) {
    return null;
  }

  return (
    marketingCategories.length > 1 && (
      <Box display="flex" flexDirection="column" alignItems="left" width="100%">
        <Tabs
          value={stringUtilities.slugify(selectedMarketingCategory)}
          onChange={setMarketingCategory}
          indicatorColor="primary"
          classes={{
            root: styles.tabs,
          }}
          centered={true}
          data-test={'variant:tabs'}
        >
          {marketingCategories.map(category => {
            const categoryIsSelected = selectedMarketingCategory.toLowerCase() === category.toLowerCase();

            return (
              <Tab
                key={category}
                value={category}
                label={<Typography variant={categoryIsSelected ? 'captionHeavy' : 'caption'}>{category}</Typography>}
                data-test={`variant:tab:${category}`}
                data-selected={categoryIsSelected}
                aria-selected={categoryIsSelected}
                classes={{
                  root: styles.tab,
                }}
              />
            );
          })}
        </Tabs>
      </Box>
    )
  );
};

export default VariantCategoryTabs;
